import { useTranslation } from "react-i18next";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFLookupVatType } from "../../../Shared/NewForms/NFLookupVatType";

export const ProductionAndSalesDetailAdvances = () => {
    const { t } = useTranslation();

    return (
        <>
            <NFormTable fieldArray={"advances"}>
                <NFIntInput title={t("advancesVat")} fieldName="advancesVat" />
                <NFIntInput title={t("Amount")} fieldName="amount" />
                <NFLookupAccount title={t("Account")} fieldName="accountId" />
                <NFLookupVatType
                    title={t("VAT Account")}
                    fieldName="vatAccountId"
                />
                <NFIntInput title={t("advancesVat")} fieldName="advancesVat" />
            </NFormTable>
        </>
    );
};
